import React from 'react';
import MapSelectorModal from '../MapSelectorModal';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class MapSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  handleCardClick(key, e) {
    // do not change filter selection if admin is using sub dropdown on the card
    if (e.target && e.target.tagName == 'SELECT') {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }

    this.props.handleCardClick(key);
    if (this.props.closeOnCardClick) {
      this.closeModal();
    }
  }

  handleKeyDown(e) {
    // holding alt and other keys will enable different map layers
    if (e.altKey) {
      const key = this.props.hotkeysHash[e.keyCode];
      if (key) {
        this.handleCardClick(key, e);
      }
    }
  }

  openModal() {
    this.setState({
      modalOpen: true
    });
    $('body').css('overflow', 'hidden');
    $('.hide-for-fullscreen-modal').css('display', 'none');
  }

  closeModal() {
    this.setState({
      modalOpen: false
    });
    $('body').css('overflow', 'unset');
    $('.hide-for-fullscreen-modal').css('display', '');
  }

  getOverlayTitleText() {
    switch (this.props.type) {
      case 'overlay':
        return StringConstantsMixin.strings.MAP_OVERLAYS;
      case 'layer':
        return StringConstantsMixin.strings.MAP_LAYERS;
      default:
        return this.props.type;
    }
  }

  renderSelectorModal() {
    if (!this.state.modalOpen) {
      return null;
    }
    return (
      <MapSelectorModal
        handleClose={this.closeModal}
        handleCardClick={this.handleCardClick}
        handleActivityFilterChange={this.props.handleActivityFilterChange}
        selectedFilterActivity={this.props.selectedFilterActivity}
        ctaFooter={this.props.getCTAFooterConfig ? this.props.getCTAFooterConfig(this.closeModal) : null}
        title={this.props.title}
        sections={this.props.getSections()}
        taller={this.props.taller}
        adminLayout={this.props.adminLayout}
        mobileBrowser={this.props.mobileBrowser}
      />
    );
  }

  render() {
    const activeClass = this.state.modalOpen ? 'active' : '';
    return (
      <div id={`map-${this.props.type}-control`} className="at-noprint">
        <div
          className={`map-control bottom-${this.props.type}s-green ${activeClass}`}
          title={this.getOverlayTitleText()}
          onClick={this.openModal}
          data-test-id={this.props.type}
        />
        {this.renderSelectorModal()}
      </div>
    );
  }
}

export default MapSelection;
